<div class="main-screen-component">
    <div class="row-content">
        <mat-card class="w-1of3" appearance="outlined">
        <h5 class="w-100 h-auto">
            Status Rekbotów u Klienta: 
            <!-- <button (click)="countRekbotsStatus()">Policz</button> -->
        </h5>
        <mat-card-content class="d-flex justify-content-center align-items-center flex-column w-100" *ngIf="!isLoading">  
        <div class="canvas-div flex-fill">
            <canvas baseChart #chartStatusRekbots type="doughnut" [data]="chartData" [options]="chartOptions" >
                </canvas>
            </div>  
          <div class="d-flex gap-3 flex-row flex-nowrap align-items-start justify-content-center w-100 pb-1">
            <span>OK: {{rekbotsStatusData.ok}}</span> 
            <span>INFO: {{rekbotsStatusData.info}}</span>
            <span>AWARIA: {{rekbotsStatusData.error}}</span> 
            <span>OFFLINE: {{rekbotsStatusData.offline}}</span>
        </div>   
    </mat-card-content>
    <mat-card-content class="d-flex justify-content-center align-items-center flex-column w-100" *ngIf="isLoading">  
        <mat-spinner></mat-spinner>
    </mat-card-content>
        
    </mat-card>
    <mat-card class="w-2of3" appearance="outlined">
        <h5 class="w-100 h-auto">Lista maszyn w awarii: </h5>
        <mat-card-content class="w-100 table-container">
            <mat-tab-group>
                <mat-tab label="Awaria">
                     <table class="table table-dark table-striped w-100">
                        <thead>
                            <tr>
                                <th scope="col">NUMER SERYJNY</th>
                                <th scope="col">OSTATNI KOMUNIKAT</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            <tr *ngFor="let rekbot of rekbotsError">
                                <th scope="row" (click)="onOpenRekbot(rekbot.id)">{{rekbot.serial_no}}</th>
                                <td>{{rekbot.namedStatus}}</td>
                            </tr>
                            
                        </tbody>
                    </table>
                </mat-tab>
                <mat-tab label="Informacje">
                    <table class="table table-dark table-striped w-100">
                        <thead>
                            <tr>
                                <th scope="col">NUMER SERYJNY</th>
                                <th scope="col">OSTATNI KOMUNIKAT</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            <tr *ngFor="let rekbot of rekbotsInfo">
                                <th scope="row" (click)="onOpenRekbot(rekbot.id)">{{rekbot.serial_no}}</th>
                                <td>{{rekbot.namedStatus }}</td>
                            </tr>
                        </tbody>
                    </table>
                </mat-tab>
            </mat-tab-group>
            
        </mat-card-content>
       


    </mat-card>
    </div>
    <div class="row-content" *ngIf="user.is_admin! > 0">
    
        <mat-card class="w-2of3" appearance="outlined">
            <h5 class="w-100 h-auto">Lista próśb usunięcia notatek: </h5>
            <mat-card-content class="w-100 table-container">
                <table class="table table-dark table-striped w-100">
                    <thead>
                        <tr>
                            <th scope="col">MASZYNA</th>
                            <th scope="col">TYTUŁ NOTATKI</th>
                            <th scope="col">AKCJE</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                        <tr *ngFor="let note of notesDeleteRequest">
                            <th scope="row">{{getRekbotSerial(note.rekbot_id)}}</th>
                            <th scope="row">{{note.title}}</th>
                            <td class="d-flex gap-2">
                                <button mat-icon-button class="mat-icon-button" (click)="onConfirmDeleteNote(note)" matTooltip="Wyświetl">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" class="mat-icon-button" (click)="cancelDeleteRequest(note)" matTooltip="Anuluj prośbę">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </td>
                        </tr>
                        
                    </tbody>

                </table>
                
            </mat-card-content>
        </mat-card>
    </div>
</div>
